import axios from "axios";

const getClientById = async (id_no) => {
  try {
    console.log("Fetching client by ID:", id_no);
    const response = await axios.get(`${process.env.REACT_APP_PYTHON_URL}/api/v1/client-information/${id_no}`);
    console.log("Client data received:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching client information:", error);
    throw error;
  }
};

const getCaseById = async (case_id) => {
  try {
    console.log("Fetching case by ID:", case_id);
    const response = await axios.get(`${process.env.REACT_APP_PYTHON_URL}/api/v1/client-information/case/${case_id}`);
    console.log("Case data received:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching case information:", error);
    throw error;
  }
};

const uploadClientData = async (data) => {
  try {
    console.log("Uploading client data:", data);
    const response = await axios.post(`${process.env.REACT_APP_PYTHON_URL}/api/v1/client-information/upload`, data);
    console.log("Upload response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error uploading client data:", error);
    throw error;
  }
};

const saveClientData = async (data) => {
  try {
    console.log("Saving client data:", data);

    const response = await axios.post(
      `${process.env.REACT_APP_PYTHON_URL}/api/v1/client-information/save`,
      data,
      {
        headers: {
          "Content-Type": "application/json", // ✅ Ensure JSON format
        },
      }
    );

    console.log("Save response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error saving client data:", error);
    throw error;
  }
};

const updateClientData = async (id_no, data) => {
  try {
    console.log("Updating client data for ID:", id_no, "with data:", data);
    const response = await axios.put(`${process.env.REACT_APP_PYTHON_URL}/api/v1/client-information/update/${id_no}`, data);
    console.log("Update response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating client data:", error);
    throw error;
  }
};

const deleteClientData = async (id_no) => {
  try {
    console.log("Deleting client data for ID:", id_no);
    const response = await axios.delete(`${process.env.REACT_APP_PYTHON_URL}/api/v1/client-information/delete/${id_no}`);
    console.log("Delete response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error deleting client data:", error);
    throw error;
  }
};

export { getClientById, getCaseById, uploadClientData, saveClientData, updateClientData, deleteClientData };
